const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAiml(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M1897.578,455.628C1176.208,434.326,551.349,957.75,456.944,1644.547 c-103.218,750.919,464.884,1426.566,1163.91,1534.781c869.471,134.602,1712.808-644.082,1637.085-1488.839 C3200.888,1054.039,2630.865,477.281,1897.578,455.628z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFC8D6"
    },
    d: "M2367.877,637.975L610.779,561.401c-26.686-1.163-48.369,21.011-48.369,49.529v2349.012 c0,28.518,21.683,49.972,48.371,47.922l1757.095-134.953c22.216-1.706,40.186-24.111,40.186-50.045V686.685 C2408.062,660.75,2390.092,638.943,2367.877,637.975z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2411.464,616.252L649.545,540.813c-26.757-1.146-48.498,21.073-48.498,49.63v2352.133 c0,28.556,21.741,50.026,48.5,47.958l1761.917-136.191c22.278-1.722,40.299-24.168,40.299-50.139v-2139.2 C2451.763,639.031,2433.742,617.205,2411.464,616.252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1526.496,660.917c0,21.045,15.29,38.693,34.119,39.415c18.793,0.721,34-15.697,34-36.668 c0-20.973-15.207-38.616-34-39.411C1541.786,623.457,1526.496,639.871,1526.496,660.917z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.74,
      fill: "#FFFFFF"
    },
    d: "M752.57,2836.656l1554.124-106.575c15.508-1.063,28.061-16.515,28.061-34.513 V798.213c0-17.998-12.553-33.046-28.061-33.612L752.57,707.931c-18.222-0.664-33.018,14.648-33.018,34.202v2061.381 C719.552,2823.068,734.348,2837.905,752.57,2836.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.51,
      fill: "#FFFFFF"
    },
    d: "M1829.881,1520.572c59.255-16.699,76.97,11.713,124.21-10.897 c56.199-26.896,97.638-96.833,104.547-166.15c9.8-98.322-52.268-172.726-95.411-224.443 c-100.667-120.674-226.493-153.7-263.878-162.928c-51.335-12.672-277.828-59.792-466.262,112.518 c-135.651,124.043-169.399,286.247-178.824,334.847c-13.757,70.939-56.954,293.698,54.983,375.541 c65.042,47.556,167.593,36.156,231.554-9.241c46.537-33.03,36.957-54.797,82.433-87.034 c89.358-63.343,150.739,9.924,252.62-40.043C1755.54,1603.66,1748.252,1543.576,1829.881,1520.572z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -1475.8046,
    y1: 1362.5901,
    x2: 180.4607,
    y2: 2765.6255,
    gradientTransform: "matrix(-1 0 0 1 516.4959 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M978.14,2824.216l97.428-652.741c16.821-112.696-16.478-225.978-90.01-305.44h-0.001 c-40.885-44.182-66.723-102.561-72.514-165.517c-9.043-98.318-7.956-258.957,51.503-454.615 c78.618-258.701,314.039-410.814,553.416-365.679c116.962,22.053,251.499,66.187,390.916,149.351 c79.289,47.297,133.284,136.034,141.807,236.522c3.962,46.72,11.299,98.461,24.622,144.435 c16.742,57.772,23.994,97.319,26.987,122.986c2.715,23.276-5.173,46.582-20.694,61.999l-0.002,0.003 c-16.008,15.901-19.986,42.585-9.458,63.483l116.104,230.478v7.484c0,23.183-15.557,42.801-35.615,44.869l-70.224,7.239 l2.667,82.749c0.515,15.982-8.625,30.577-22.078,35.231l-16.136,5.582l14.726,13.036c11.966,10.594,15.108,29.89,7.391,45.37 l-20.783,41.689c-9.414,18.885-8.066,42.065,3.402,58.518l0,0c18.955,27.195,22.822,64.763,10.055,97.618l-5.804,14.936 c-26.899,69.225-91.144,110.692-155.706,99.805c-73.713-12.43-169.018-33.34-235.024-65.406 c-18.856-9.16-40.621,7.557-40.621,31.065v370.443L978.14,2824.216z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1112.816,1383.962l298.358,1.021c0.617,0.002,1.209-0.257,1.656-0.728l90.398-94.781 l388.962,3.251c1.266,0.01,2.291-1.148,2.291-2.59c0-1.441-1.025-2.617-2.291-2.628l-389.912-3.367 c-0.611-0.005-1.198,0.25-1.641,0.717l-90.422,94.773l-296.37-1.096l-44.059-48.348c-0.468-0.513-1.101-0.803-1.764-0.807 l-47.504-0.293c-1.385-0.008-2.506,1.205-2.506,2.713c0,1.508,1.121,2.735,2.506,2.743l46.471,0.274l44.072,48.344 C1111.526,1383.671,1112.156,1383.959,1112.816,1383.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1110.333,1356.796l298.432,1.431c0.617,0.003,1.209-0.255,1.656-0.725l90.42-94.669 l391.348,3.808c1.266,0.012,2.291-1.145,2.291-2.586c0-1.442-1.025-2.618-2.291-2.631l-392.299-3.925 c-0.611-0.006-1.198,0.248-1.641,0.714l-90.444,94.66l-296.444-1.502l-44.07-48.414c-0.468-0.514-1.102-0.806-1.764-0.811 l-29.984-0.226c-1.383-0.01-2.503,1.201-2.503,2.708c0,1.506,1.12,2.734,2.503,2.744l28.95,0.21l44.083,48.411 C1109.042,1356.504,1109.673,1356.793,1110.333,1356.796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1107.848,1329.624l298.507,1.841c0.617,0.004,1.209-0.254,1.657-0.724l90.442-94.556 l378.256,4.2c1.269,0.014,2.295-1.142,2.295-2.584c0-1.443-1.026-2.622-2.295-2.637l-379.207-4.314 c-0.611-0.007-1.198,0.246-1.642,0.712l-90.467,94.548l-296.518-1.91l-44.082-48.481c-0.467-0.514-1.101-0.807-1.764-0.813 l-17.484-0.155c-1.382-0.013-2.5,1.196-2.5,2.703c0,1.506,1.118,2.734,2.5,2.746l16.451,0.142l44.093,48.477 C1106.558,1329.33,1107.189,1329.62,1107.848,1329.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1105.364,1302.445l298.581,2.25c0.617,0.005,1.21-0.252,1.657-0.721l90.465-94.444 l380.643,4.748c1.269,0.016,2.295-1.139,2.295-2.582c0-1.443-1.026-2.623-2.295-2.639l-381.595-4.865 c-0.611-0.008-1.199,0.245-1.642,0.709l-90.49,94.435l-296.592-2.317l-44.093-48.547c-0.974-1.073-2.554-1.09-3.529-0.036 c-0.975,1.054-0.975,2.777,0,3.85l44.837,49.349C1104.073,1302.15,1104.704,1302.44,1105.364,1302.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1117.781,1796.606c0.635-0.011,1.27-0.287,1.755-0.826l79.084-87.889 c0.461-0.513,0.721-1.203,0.721-1.921v-302.788c0-1.494-1.101-2.706-2.461-2.71c-1.361-0.004-2.462,1.203-2.462,2.698v301.744 l-78.391,87.088c-0.969,1.077-0.969,2.796,0,3.839C1116.51,1796.363,1117.145,1796.617,1117.781,1796.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1085.465,1786.292c0.637-0.011,1.274-0.287,1.76-0.826l86.748-96.204 c0.463-0.513,0.723-1.204,0.723-1.923v-284.219c0-1.496-1.104-2.709-2.468-2.713c-1.364-0.003-2.468,1.205-2.468,2.701v283.169 l-86.056,95.403c-0.973,1.079-0.973,2.799,0,3.845C1084.191,1786.049,1084.828,1786.303,1085.465,1786.292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1060.536,1767.656c0.638-0.01,1.277-0.286,1.764-0.825l86.966-96.242 c0.463-0.514,0.724-1.205,0.724-1.925v-265.603c0-1.498-1.106-2.713-2.474-2.717c-1.368-0.004-2.474,1.206-2.474,2.704v264.547 l-86.272,95.441c-0.975,1.079-0.975,2.802,0,3.85C1059.258,1767.411,1059.897,1767.666,1060.536,1767.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1035.543,1748.972c0.641-0.01,1.281-0.285,1.77-0.825l87.184-96.281 c0.465-0.514,0.727-1.205,0.727-1.926V1403c0-1.5-1.109-2.716-2.481-2.72c-1.371-0.003-2.48,1.208-2.48,2.708v245.879 l-86.489,95.479c-0.978,1.079-0.978,2.804,0,3.855C1034.262,1748.725,1034.902,1748.982,1035.543,1748.972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1018.011,1721.951c0.641-0.008,1.282-0.284,1.772-0.824l79.882-88.03 c0.466-0.514,0.729-1.206,0.729-1.928v-228.231c0-1.502-1.113-2.72-2.486-2.723c-1.375-0.004-2.487,1.209-2.487,2.711v227.163 l-79.182,87.228c-0.979,1.079-0.979,2.806,0,3.858C1016.728,1721.702,1017.369,1721.96,1018.011,1721.951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1667.889,1596.997c0.599-0.005,1.2-0.266,1.658-0.785c0.916-1.038,0.916-2.708,0-3.732 l-87.169-97.446c-0.444-0.497-1.045-0.775-1.673-0.773l-359.238,0.791c-1.357,0.003-2.456,1.213-2.456,2.706 c0,1.493,1.099,2.699,2.456,2.695l358.258-0.887l86.505,96.671C1666.688,1596.748,1667.289,1597.002,1667.889,1596.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1679.61,1573.17c0.6-0.004,1.199-0.266,1.657-0.783c0.915-1.036,0.915-2.705,0-3.729 l-87.063-97.495c-0.443-0.496-1.043-0.775-1.671-0.775l-358.794,0.347c-1.356,0.001-2.453,1.21-2.453,2.701 c0,1.493,1.097,2.698,2.453,2.696l357.815-0.444l86.4,96.719C1678.411,1572.92,1679.011,1573.174,1679.61,1573.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1691.318,1549.372c0.599-0.003,1.197-0.263,1.654-0.78c0.914-1.034,0.914-2.702,0-3.727 l-86.956-97.543c-0.442-0.497-1.042-0.776-1.669-0.776l-358.351-0.096c-1.354,0-2.45,1.206-2.45,2.698 c0,1.49,1.096,2.697,2.45,2.697l357.373-0.003l86.295,96.767C1690.12,1549.121,1690.719,1549.375,1691.318,1549.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1703.01,1525.604c0.598-0.002,1.196-0.262,1.652-0.778c0.913-1.032,0.913-2.7,0-3.725 l-86.85-97.59c-0.443-0.497-1.041-0.777-1.667-0.778l-357.909-0.538c-1.353-0.002-2.447,1.202-2.447,2.692 c0,1.49,1.094,2.697,2.447,2.699l356.933,0.438l86.189,96.815C1701.814,1525.351,1702.412,1525.606,1703.01,1525.604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1890.757,1506.621c0.586-0.002,1.173-0.258,1.62-0.769l72.755-83.032 c0.426-0.486,0.666-1.146,0.666-1.836v-180.26c0-0.69-0.24-1.352-0.666-1.845l-102.202-117.943v-24.39 c0-1.444-1.028-2.632-2.299-2.655c-1.27-0.024-2.299,1.126-2.299,2.57v25.477c0,0.694,0.242,1.362,0.674,1.859l102.244,117.952 V1419.9l-72.114,82.271c-0.895,1.022-0.895,2.672,0,3.689C1889.584,1506.369,1890.171,1506.622,1890.757,1506.621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1867.813,1501.463c0.587-0.001,1.175-0.258,1.624-0.77l72.93-83.112 c0.427-0.487,0.668-1.146,0.668-1.838v-180.476c0-0.691-0.24-1.354-0.668-1.847l-102.449-118.115v-34.882 c0-1.446-1.031-2.636-2.304-2.661c-1.274-0.025-2.305,1.125-2.305,2.571v35.973c0,0.695,0.242,1.363,0.675,1.862 l102.491,118.124v178.365l-72.287,82.351c-0.897,1.023-0.897,2.675,0,3.694 C1866.637,1501.211,1867.225,1501.465,1867.813,1501.463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1844.813,1496.293c0.589-0.002,1.178-0.258,1.628-0.77l73.106-83.192 c0.429-0.488,0.669-1.149,0.669-1.841v-180.693c0-0.692-0.241-1.356-0.669-1.849l-102.696-118.287v-50.636 c0-1.447-1.033-2.64-2.31-2.667c-1.277-0.026-2.31,1.124-2.31,2.572v51.733c0,0.696,0.244,1.365,0.677,1.864l102.739,118.296 v178.58l-72.462,82.431c-0.9,1.024-0.9,2.678,0,3.698C1843.635,1496.041,1844.224,1496.295,1844.813,1496.293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1805.297,1506.868c1.278-0.004,2.312-1.179,2.312-2.627v-22.495l66.134-75.057 c0.43-0.489,0.673-1.151,0.673-1.844v-93.991c0-1.444-1.027-2.619-2.296-2.629c-1.27-0.009-2.297,1.151-2.297,2.595v92.932 l-66.161,75.062c-0.434,0.492-0.678,1.158-0.678,1.854v23.586C1802.984,1505.702,1804.019,1506.871,1805.297,1506.868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1782.146,1506.934c1.281-0.004,2.318-1.18,2.318-2.63v-22.523l66.294-75.148 c0.432-0.49,0.674-1.153,0.674-1.847v-94.105c0-1.445-1.03-2.622-2.302-2.631c-1.273-0.01-2.302,1.152-2.302,2.597v93.045 l-66.321,75.153c-0.434,0.492-0.679,1.159-0.679,1.856v23.615C1779.827,1505.767,1780.865,1506.938,1782.146,1506.934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1758.938,1507.001c1.284-0.004,2.323-1.182,2.323-2.633v-22.55l66.455-75.239 c0.432-0.49,0.676-1.154,0.676-1.849v-94.218c0-1.447-1.032-2.625-2.307-2.635c-1.276-0.01-2.307,1.154-2.307,2.601v93.157 l-66.482,75.244c-0.436,0.493-0.681,1.16-0.681,1.858v23.644C1756.614,1505.833,1757.654,1507.005,1758.938,1507.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1735.674,1507.068c1.288-0.004,2.329-1.183,2.329-2.636v-22.577l66.616-75.33 c0.434-0.49,0.678-1.155,0.678-1.851v-94.333c0-1.448-1.034-2.628-2.313-2.638c-1.278-0.009-2.313,1.155-2.313,2.604v93.27 l-66.644,75.335c-0.436,0.494-0.682,1.162-0.682,1.861v23.672C1733.345,1505.899,1734.387,1507.072,1735.674,1507.068z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1738.003,1428.174c0.596,0.001,1.192-0.255,1.646-0.768c0.909-1.026,0.909-2.689,0-3.718 l-63.069-71.318c-0.44-0.497-1.035-0.779-1.657-0.782l-191.755-0.998c-1.322-0.007-2.391,1.18-2.391,2.652 c0,1.473,1.069,2.67,2.391,2.677l190.784,0.941l62.404,70.542C1736.812,1427.916,1737.408,1428.173,1738.003,1428.174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1206.722,1795.056c0.629-0.011,1.258-0.285,1.739-0.821l140.889-157.272l238.454-2.258 c1.307-0.013,2.365-1.207,2.365-2.672v-95.395c0-1.465-1.058-2.645-2.365-2.64c-1.308,0.005-2.366,1.195-2.366,2.66v92.768 l-237.092,2.181c-0.643,0.006-1.259,0.295-1.714,0.802l-141.649,158.065c-0.961,1.072-0.961,2.783,0,3.822 C1205.463,1794.814,1206.092,1795.067,1206.722,1795.056z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1162.351,1795.829c0.632-0.011,1.264-0.286,1.746-0.823l165.841-184.714l238.924-1.935 c1.31-0.01,2.37-1.205,2.37-2.672v-95.489c0-1.466-1.059-2.649-2.37-2.646c-1.31,0.004-2.37,1.194-2.37,2.66v92.859 l-237.56,1.859c-0.645,0.005-1.262,0.293-1.718,0.801l-166.61,185.507c-0.965,1.075-0.965,2.789,0,3.831 C1161.087,1795.587,1161.719,1795.84,1162.351,1795.829z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1219.011,1684.11c0.628-0.007,1.257-0.279,1.737-0.812l89.741-99.732l239.396-1.611 c1.313-0.009,2.374-1.203,2.374-2.671v-69.031c0-1.467-1.062-2.652-2.374-2.648c-1.312,0.003-2.375,1.195-2.375,2.662v66.393 l-238.029,1.536c-0.647,0.004-1.265,0.292-1.721,0.798l-90.485,100.525c-0.96,1.067-0.96,2.776,0,3.82 C1217.755,1683.861,1218.383,1684.118,1219.011,1684.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1221.467,1611.17c0.629-0.005,1.257-0.274,1.736-0.805l62.918-69.699l239.989-1.088 c1.315-0.006,2.38-1.2,2.38-2.669c0-1.469-1.065-2.654-2.38-2.648l-240.999,1.026c-0.648,0.003-1.268,0.289-1.725,0.796 l-63.656,70.491c-0.959,1.063-0.959,2.772,0,3.819C1220.211,1610.916,1220.839,1611.175,1221.467,1611.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1127.703,1242.922l264.182,2.788c0.641,0.007,1.254-0.269,1.707-0.766l72.124-79.244 c0.449-0.494,0.702-1.167,0.702-1.875v-128.008c0-0.708-0.253-1.39-0.702-1.901l-57.656-65.435 c-0.941-1.068-2.466-1.106-3.408-0.084c-0.941,1.022-0.941,2.715,0,3.783l56.975,64.639v125.83l-70.74,77.696l-262.157-2.839 l-31.551-34.873c-0.972-1.074-2.546-1.094-3.517-0.044c-0.972,1.049-0.972,2.77,0,3.844l32.289,35.676 C1126.415,1242.621,1127.044,1242.915,1127.703,1242.922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1137.615,1205.059l230.106,2.87c1.337,0.016,2.419-1.169,2.419-2.65V980.156 c0-1.481-1.082-2.707-2.419-2.739c-1.338-0.032-2.42,1.14-2.42,2.622v222.498l-227.686-2.903 c-1.369-0.017-2.477,1.181-2.477,2.681S1136.246,1205.042,1137.615,1205.059z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1100.393,1180.142l245.528,3.366c1.34,0.018,2.424-1.167,2.424-2.65V993.045 c0-1.483-1.084-2.708-2.424-2.74c-1.34-0.031-2.425,1.143-2.425,2.627v185.174l-243.103-3.399 c-1.375-0.02-2.486,1.181-2.486,2.682C1097.907,1178.892,1099.018,1180.123,1100.393,1180.142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1120.262,1150.556l198.95,3.028c1.344,0.021,2.431-1.165,2.431-2.65v-147.768 c0-1.484-1.088-2.712-2.431-2.743c-1.344-0.031-2.432,1.146-2.432,2.631v145.118l-196.518-3.045 c-1.371-0.021-2.482,1.176-2.482,2.677C1117.781,1149.304,1118.891,1150.535,1120.262,1150.556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1007.978,1678.412c1.387-0.016,2.509-1.249,2.509-2.758v-69.833l34.327-37.613 c0.469-0.514,0.733-1.207,0.733-1.931v-190.719c0-1.506-1.118-2.729-2.5-2.735c-1.382-0.005-2.501,1.209-2.501,2.716v189.639 l-34.342,37.616c-0.471,0.515-0.735,1.21-0.735,1.935v70.981C1005.469,1677.22,1006.591,1678.427,1007.978,1678.412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1509.433,1175.105c0.61,0.009,1.22-0.243,1.686-0.756l58.725-64.699l200.705,3.55 c1.283,0.023,2.321-1.132,2.321-2.584v-70.87c0-1.451-1.038-2.647-2.321-2.675c-1.282-0.028-2.321,1.124-2.321,2.575v68.261 l-199.365-3.581c-0.629-0.011-1.231,0.258-1.675,0.747l-59.44,65.464c-0.932,1.026-0.932,2.71,0,3.763 C1508.213,1174.828,1508.823,1175.096,1509.433,1175.105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1480.777,1142.718c0.611,0.01,1.223-0.24,1.69-0.754l58.899-64.696l201.294,3.891 c1.286,0.025,2.327-1.13,2.327-2.584v-60.458c0-1.453-1.041-2.652-2.327-2.682c-1.287-0.029-2.328,1.123-2.328,2.577v57.844 l-199.95-3.92c-0.632-0.012-1.235,0.256-1.681,0.746l-59.615,65.46c-0.934,1.026-0.934,2.713,0,3.769 C1479.553,1142.439,1480.165,1142.708,1480.777,1142.718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1485.958,1073.088c0.612,0.012,1.223-0.237,1.69-0.748l25.157-27.55l201.884,4.236 c1.29,0.027,2.334-1.129,2.334-2.584v-34.222c0-1.455-1.044-2.656-2.334-2.686c-1.29-0.03-2.335,1.124-2.335,2.579v31.597 l-200.537-4.262c-0.634-0.013-1.239,0.254-1.686,0.744l-25.864,28.315c-0.934,1.023-0.934,2.708,0,3.768 C1484.735,1072.803,1485.347,1073.076,1485.958,1073.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1393.092,1193.523c0.618,0.008,1.235-0.245,1.706-0.761l49.336-54.078 c0.451-0.494,0.703-1.168,0.703-1.877v-93.442c0-0.71-0.253-1.392-0.703-1.903l-36.075-40.882 c-0.941-1.067-2.466-1.102-3.408-0.079c-0.941,1.024-0.941,2.716,0,3.783l35.384,40.086v91.255l-48.649,53.307 c-0.943,1.033-0.943,2.728,0,3.786C1391.857,1193.245,1392.474,1193.515,1393.092,1193.523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1826.085,1187.472c0.59,0.008,1.181-0.239,1.631-0.744c0.901-1.01,0.901-2.666,0-3.701 l-41.615-47.8c-0.435-0.499-1.023-0.786-1.638-0.796l-187.203-3.105c-1.306-0.022-2.363,1.146-2.363,2.61 c0,1.464,1.057,2.666,2.363,2.688l186.244,3.038l40.95,47.02C1824.904,1187.2,1825.495,1187.464,1826.085,1187.472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1511.818,1007.521l179.5,4.11c1.293,0.03,2.339-1.125,2.339-2.582 c0-1.457-1.046-2.66-2.339-2.69l-178.513-4.136l-44.694-50.92c-0.935-1.066-2.451-1.105-3.386-0.087 c-0.936,1.018-0.936,2.706,0,3.771l45.408,51.716C1510.579,1007.212,1511.184,1007.506,1511.818,1007.521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1162.351,1118.694l98.331,1.658c0.649,0.011,1.271-0.263,1.729-0.76l29.303-31.794 c0.457-0.496,0.715-1.175,0.715-1.89v-64.576c0-1.488-1.091-2.715-2.438-2.745c-1.348-0.03-2.439,1.15-2.439,2.638v63.479 l-27.882,30.242l-97.318-1.668c-1.366-0.024-2.471,1.169-2.471,2.666C1159.88,1117.441,1160.985,1118.671,1162.351,1118.694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1502.277,1172.341c0,4.41,3.205,8.03,7.156,8.085c3.949,0.055,7.151-3.473,7.151-7.88 c0-4.407-3.201-8.027-7.151-8.085C1505.482,1164.402,1502.277,1167.931,1502.277,1172.341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1478.386,1134.684c0,4.416,3.213,8.047,7.174,8.11c3.96,0.063,7.169-3.463,7.169-7.875 c0-4.413-3.209-8.044-7.169-8.11C1481.599,1126.743,1478.386,1130.269,1478.386,1134.684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1478.386,1070.276c0,4.416,3.213,8.058,7.174,8.134c3.96,0.076,7.169-3.44,7.169-7.852 c0-4.412-3.209-8.054-7.169-8.133C1481.599,1062.345,1478.386,1065.86,1478.386,1070.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1591.351,1133.878c0,4.39,3.175,8,7.09,8.063c3.914,0.063,7.086-3.443,7.086-7.829 s-3.172-7.997-7.086-8.063C1594.526,1125.982,1591.351,1129.488,1591.351,1133.878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1819.161,1184.757c0,4.339,3.101,7.898,6.924,7.95c3.822,0.052,6.92-3.421,6.92-7.756 c0-4.335-3.098-7.894-6.92-7.949C1822.262,1176.947,1819.161,1180.42,1819.161,1184.757z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1763.585,1039.547c0,4.351,3.119,7.944,6.964,8.025c3.845,0.081,6.96-3.377,6.96-7.725 c0-4.348-3.115-7.941-6.96-8.025C1766.704,1031.737,1763.585,1035.195,1763.585,1039.547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1735.675,1010.017c0,4.358,3.128,7.961,6.985,8.048c3.855,0.087,6.979-3.372,6.979-7.726 c0-4.354-3.124-7.957-6.979-8.047C1738.803,1002.2,1735.675,1005.66,1735.675,1010.017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1707.683,1009.372c0,4.364,3.137,7.972,7.006,8.06c3.866,0.087,7-3.377,7-7.737 s-3.134-7.969-7-8.059C1710.821,1001.545,1707.683,1005.009,1707.683,1009.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1684.296,1008.833c0,4.37,3.145,7.982,7.022,8.07c3.876,0.087,7.018-3.38,7.018-7.747 c0-4.365-3.141-7.978-7.018-8.069C1687.44,1000.996,1684.296,1004.465,1684.296,1008.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1459.23,952.96c0,4.42,3.219,8.085,7.188,8.185c3.967,0.1,7.182-3.4,7.182-7.817 c0-4.417-3.215-8.081-7.182-8.184C1462.448,945.04,1459.23,948.54,1459.23,952.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1807.609,1058.835c0,4.341,3.104,7.922,6.932,8c3.827,0.077,6.928-3.377,6.928-7.714 s-3.101-7.919-6.928-8C1810.714,1051.04,1807.609,1054.493,1807.609,1058.835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1830.698,1080.245c0,4.336,3.097,7.91,6.916,7.982c3.818,0.073,6.911-3.38,6.911-7.714 c0-4.332-3.093-7.906-6.911-7.982C1833.796,1072.455,1830.698,1075.909,1830.698,1080.245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1853.733,1096.375c0,4.331,3.09,7.898,6.899,7.967c3.809,0.069,6.895-3.383,6.895-7.71 s-3.086-7.894-6.895-7.967C1856.822,1088.593,1853.733,1092.045,1853.733,1096.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1869.823,1211.581c0,4.326,3.084,7.872,6.888,7.918c3.802,0.046,6.882-3.421,6.882-7.745 c0-4.324-3.081-7.87-6.882-7.919C1872.907,1203.787,1869.823,1207.254,1869.823,1211.581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1869.823,1237.696c0,4.327,3.084,7.868,6.888,7.909c3.802,0.041,6.882-3.431,6.882-7.755 c0-4.323-3.081-7.864-6.882-7.908C1872.907,1229.898,1869.823,1233.37,1869.823,1237.696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1882.447,1263.936c0,4.324,3.081,7.858,6.879,7.894c3.797,0.036,6.874-3.438,6.874-7.758 c0-4.321-3.077-7.856-6.874-7.895C1885.527,1256.138,1882.447,1259.612,1882.447,1263.936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1882.447,1290.033c0,4.324,3.081,7.854,6.879,7.885c3.797,0.031,6.874-3.447,6.874-7.768 c0-4.32-3.077-7.851-6.874-7.885C1885.527,1282.232,1882.447,1285.71,1882.447,1290.033z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1475.994,1353.218c0,4.417,3.213,8.012,7.175,8.03c3.961,0.019,7.17-3.544,7.17-7.958 c0-4.413-3.209-8.008-7.17-8.03C1479.207,1345.239,1475.994,1348.802,1475.994,1353.218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1731.016,1424.22c0,4.358,3.129,7.895,6.988,7.899c3.858,0.003,6.984-3.524,6.984-7.879 c0-4.355-3.126-7.892-6.984-7.899C1734.145,1416.334,1731.016,1419.862,1731.016,1424.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1872.12,1303.002c-3.805-0.03-6.891,3.455-6.891,7.783c0,4.328,3.086,7.858,6.891,7.884 c3.804,0.027,6.886-3.458,6.886-7.783C1879.006,1306.561,1875.923,1303.032,1872.12,1303.002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1849.13,1302.822c-3.814-0.03-6.908,3.458-6.908,7.792c0,4.333,3.093,7.867,6.908,7.894 c3.813,0.027,6.903-3.462,6.903-7.792C1856.033,1306.386,1852.943,1302.852,1849.13,1302.822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1826.085,1302.642c-3.823-0.03-6.924,3.463-6.924,7.802c0,4.338,3.101,7.877,6.924,7.904 c3.822,0.026,6.92-3.466,6.92-7.802C1833.005,1306.21,1829.907,1302.672,1826.085,1302.642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1802.985,1302.462c-3.833-0.03-6.941,3.467-6.941,7.811c0,4.343,3.108,7.886,6.941,7.913 c3.831,0.027,6.936-3.47,6.936-7.81C1809.921,1306.035,1806.816,1302.492,1802.985,1302.462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1805.297,1496.386c-3.832,0.009-6.939,3.537-6.939,7.881c0,4.343,3.107,7.854,6.939,7.841 c3.83-0.012,6.934-3.54,6.934-7.88C1812.231,1499.888,1809.127,1496.377,1805.297,1496.386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1782.146,1496.44c-3.841,0.009-6.956,3.541-6.956,7.89c0,4.348,3.115,7.864,6.956,7.851 c3.84-0.012,6.952-3.545,6.952-7.89C1789.098,1499.946,1785.986,1496.431,1782.146,1496.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1758.939,1496.494c-3.851,0.009-6.974,3.546-6.974,7.9c0,4.353,3.123,7.873,6.974,7.86 c3.849-0.012,6.968-3.549,6.968-7.899C1765.907,1500.005,1762.788,1496.485,1758.939,1496.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1735.675,1496.548c-3.86,0.009-6.99,3.55-6.99,7.909c0,4.359,3.13,7.882,6.99,7.87 c3.858-0.012,6.985-3.553,6.985-7.909C1742.66,1500.063,1739.533,1496.54,1735.675,1496.548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1846.828,1485.83c-3.815,0.007-6.91,3.526-6.91,7.859c0,4.334,3.094,7.839,6.91,7.83 c3.814-0.01,6.904-3.529,6.904-7.859C1853.733,1489.329,1850.642,1485.824,1846.828,1485.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1869.823,1491.012c-3.806,0.008-6.892,3.523-6.892,7.852c0,4.328,3.086,7.828,6.892,7.817 c3.805-0.011,6.888-3.526,6.888-7.851C1876.711,1494.504,1873.628,1491.004,1869.823,1491.012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1892.19,1496.182c-3.797,0.009-6.876,3.521-6.876,7.845c0,4.323,3.079,7.818,6.876,7.806 c3.796-0.012,6.871-3.524,6.871-7.844C1899.061,1499.669,1895.986,1496.174,1892.19,1496.182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1196.879,1395.065c-4.08-0.012-7.388,3.612-7.388,8.093c0,4.482,3.308,8.122,7.388,8.13 c4.079,0.009,7.383-3.615,7.383-8.093C1204.262,1398.716,1200.958,1395.076,1196.879,1395.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1172.229,1394.994c-4.09-0.012-7.407,3.616-7.407,8.103c0,4.487,3.317,8.132,7.407,8.14 c4.088,0.008,7.401-3.62,7.401-8.104C1179.63,1398.65,1176.317,1395.006,1172.229,1394.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1147.517,1394.923c-4.101-0.012-7.426,3.62-7.426,8.113c0,4.493,3.325,8.142,7.426,8.151 c4.099,0.008,7.419-3.624,7.419-8.114C1154.937,1398.584,1151.616,1394.934,1147.517,1394.923z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1122.743,1394.852c-4.11-0.011-7.444,3.625-7.444,8.124c0,4.499,3.334,8.152,7.444,8.161 c4.109,0.008,7.439-3.629,7.439-8.124C1130.182,1398.517,1126.852,1394.864,1122.743,1394.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1097.907,1394.78c-4.121-0.012-7.463,3.63-7.463,8.134c0,4.504,3.341,8.162,7.463,8.171 c4.12,0.009,7.457-3.633,7.457-8.134C1105.364,1398.45,1102.027,1394.792,1097.907,1394.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1043.048,1367.373c-4.144-0.017-7.504,3.63-7.504,8.146c0,4.516,3.361,8.189,7.504,8.203 c4.142,0.014,7.498-3.633,7.498-8.146C1050.546,1371.064,1047.19,1367.391,1043.048,1367.373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1038.046,1296.487c-4.146-0.032-7.508,3.604-7.508,8.121c0,4.517,3.362,8.203,7.508,8.232 c4.144,0.029,7.503-3.607,7.503-8.121C1045.548,1300.205,1042.19,1296.52,1038.046,1296.487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1045.548,1269.3c-4.143-0.038-7.503,3.592-7.503,8.108c0,4.516,3.359,8.205,7.503,8.24 c4.141,0.035,7.497-3.595,7.497-8.108C1053.045,1273.027,1049.689,1269.339,1045.548,1269.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1025.529,1323.662c-4.151-0.026-7.518,3.616-7.518,8.136c0,4.52,3.366,8.204,7.518,8.228 c4.149,0.023,7.512-3.62,7.512-8.137C1033.041,1327.373,1029.678,1323.689,1025.529,1323.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1060.536,1242.213c-4.137-0.044-7.491,3.579-7.491,8.092c0,4.512,3.354,8.203,7.491,8.243 c4.135,0.04,7.485-3.582,7.485-8.091C1068.021,1245.947,1064.671,1242.256,1060.536,1242.213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1095.42,1196.719c-4.122-0.053-7.465,3.555-7.465,8.06c0,4.504,3.343,8.196,7.465,8.246 c4.12,0.05,7.459-3.559,7.459-8.06C1102.879,1200.464,1099.54,1196.772,1095.42,1196.719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1137.615,1194.211c-4.104-0.053-7.433,3.547-7.433,8.043c0,4.495,3.329,8.179,7.433,8.229 c4.103,0.05,7.428-3.55,7.428-8.042C1145.043,1197.949,1141.718,1194.265,1137.615,1194.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1100.394,1169.273c-4.12-0.058-7.461,3.545-7.461,8.047c0,4.504,3.341,8.2,7.461,8.255 c4.118,0.055,7.455-3.548,7.455-8.048C1107.849,1173.028,1104.512,1169.332,1100.394,1169.273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1123.053,1139.743c-4.11-0.065-7.444,3.53-7.444,8.028c0,4.498,3.334,8.194,7.444,8.256 c4.109,0.061,7.439-3.533,7.439-8.027C1130.492,1143.504,1127.162,1139.808,1123.053,1139.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1162.352,1107.861c-4.094-0.071-7.415,3.51-7.415,7.999c0,4.49,3.321,8.183,7.415,8.251 c4.093,0.068,7.409-3.513,7.409-7.999C1169.76,1111.626,1166.444,1107.932,1162.352,1107.861z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1289.991,1013.205c-4.041-0.09-7.319,3.453-7.319,7.913c0,4.46,3.278,8.146,7.319,8.234 c4.04,0.087,7.314-3.456,7.314-7.912C1297.304,1016.982,1294.031,1013.296,1289.991,1013.205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1319.212,995.049c-4.029-0.094-7.297,3.441-7.297,7.894c0,4.454,3.268,8.138,7.297,8.228 c4.028,0.091,7.292-3.443,7.292-7.894C1326.504,998.827,1323.24,995.143,1319.212,995.049z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1345.922,984.938c-4.018-0.096-7.277,3.432-7.277,7.88c0,4.447,3.259,8.128,7.277,8.22 c4.017,0.093,7.272-3.435,7.272-7.879C1353.194,988.715,1349.939,985.034,1345.922,984.938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1367.722,972.057c-4.01-0.099-7.261,3.423-7.261,7.865c0,4.443,3.251,8.121,7.261,8.217 c4.008,0.095,7.255-3.427,7.255-7.866C1374.977,975.834,1371.729,972.155,1367.722,972.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1407.159,994.425c-3.993-0.094-7.231,3.425-7.231,7.858c0,4.434,3.238,8.101,7.231,8.192 c3.992,0.091,7.227-3.428,7.227-7.859C1414.386,998.185,1411.151,994.518,1407.159,994.425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1407.159,962.325c-3.993-0.1-7.231,3.412-7.231,7.846c0,4.434,3.238,8.107,7.231,8.204 c3.992,0.097,7.227-3.416,7.227-7.847C1414.386,966.098,1411.151,962.425,1407.159,962.325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1393.093,1181.477c-3.999-0.055-7.242,3.497-7.242,7.934c0,4.436,3.243,8.075,7.242,8.127 c3.997,0.052,7.237-3.5,7.237-7.933C1400.33,1185.171,1397.09,1181.532,1393.093,1181.477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1221.468,1489.65c-4.07,0.008-7.371,3.643-7.371,8.118c0,4.477,3.301,8.096,7.371,8.085 c4.068-0.011,7.364-3.646,7.364-8.119C1228.833,1493.262,1225.536,1489.643,1221.468,1489.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1233.739,1465.338c-4.064,0.003-7.361,3.631-7.361,8.104c0,4.473,3.297,8.094,7.361,8.088 c4.063-0.006,7.356-3.634,7.356-8.104C1241.095,1468.956,1237.802,1465.335,1233.739,1465.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1245.995,1441.056c-4.059-0.002-7.351,3.62-7.351,8.091c0,4.47,3.292,8.093,7.351,8.092 c4.058-0.001,7.347-3.623,7.347-8.09C1253.342,1444.681,1250.053,1441.058,1245.995,1441.056z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1258.236,1416.804c-4.055-0.007-7.343,3.609-7.343,8.076c0,4.468,3.288,8.093,7.343,8.096 c4.052,0.004,7.337-3.612,7.337-8.076C1265.573,1420.436,1262.289,1416.811,1258.236,1416.804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1524.524,1528.949c-3.946,0.016-7.145,3.601-7.145,8.009c0,4.406,3.2,7.964,7.145,7.945 c3.944-0.019,7.14-3.604,7.14-8.008S1528.468,1528.933,1524.524,1528.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1221.468,1599.018c-4.07,0.03-7.371,3.684-7.371,8.16c0,4.475,3.301,8.077,7.371,8.043 c4.068-0.034,7.364-3.687,7.364-8.159C1228.833,1602.589,1225.536,1598.987,1221.468,1599.018z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1219.012,1673.307c-4.07,0.046-7.372,3.711-7.372,8.188c0,4.476,3.302,8.065,7.372,8.016 c4.069-0.049,7.367-3.715,7.367-8.188C1226.378,1676.85,1223.081,1673.261,1219.012,1673.307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1549.885,1502.294c-3.935,0.01-7.126,3.586-7.126,7.987c0,4.402,3.191,7.959,7.126,7.945 c3.934-0.013,7.121-3.589,7.121-7.988C1557.007,1505.841,1553.819,1502.284,1549.885,1502.294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1568.863,1502.245c-3.927,0.01-7.112,3.583-7.112,7.98c0,4.397,3.185,7.951,7.112,7.937 c3.926-0.014,7.107-3.586,7.107-7.98C1575.97,1505.788,1572.789,1502.234,1568.863,1502.245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1587.804,1528.697c-3.92,0.016-7.099,3.589-7.099,7.982c0,4.392,3.179,7.938,7.099,7.919 c3.917-0.019,7.093-3.592,7.093-7.982S1591.722,1528.681,1587.804,1528.697z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1667.889,1586.441c-3.887,0.027-7.04,3.595-7.04,7.969c0,4.375,3.153,7.896,7.04,7.865 c3.886-0.03,7.034-3.598,7.034-7.97S1671.775,1586.413,1667.889,1586.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1679.611,1562.62c-3.883,0.022-7.031,3.585-7.031,7.956c0,4.372,3.148,7.895,7.031,7.87 c3.88-0.026,7.026-3.588,7.026-7.956C1686.637,1566.12,1683.492,1562.597,1679.611,1562.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1691.318,1538.828c-3.878,0.018-7.022,3.574-7.022,7.942c0,4.37,3.145,7.895,7.022,7.874 c3.876-0.021,7.018-3.577,7.018-7.943C1698.336,1542.336,1695.194,1538.811,1691.318,1538.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1703.011,1515.066c-3.873,0.013-7.014,3.563-7.014,7.93c0,4.366,3.141,7.892,7.014,7.876 c3.872-0.016,7.009-3.566,7.009-7.929S1706.882,1515.053,1703.011,1515.066z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1206.722,1784.246c-4.076,0.069-7.382,3.755-7.382,8.235c0,4.479,3.306,8.052,7.382,7.98 c4.074-0.072,7.375-3.759,7.375-8.235C1214.098,1787.75,1210.796,1784.177,1206.722,1784.246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1162.352,1784.995c-4.094,0.069-7.415,3.765-7.415,8.254c0,4.489,3.321,8.07,7.415,7.997 c4.093-0.073,7.409-3.768,7.409-8.254C1169.76,1788.507,1166.444,1784.926,1162.352,1784.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1117.781,1785.747c-4.113,0.069-7.448,3.773-7.448,8.273c0,4.499,3.335,8.088,7.448,8.015 c4.111-0.073,7.442-3.776,7.442-8.273C1125.224,1789.266,1121.892,1785.678,1117.781,1785.747z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1085.466,1775.416c-4.126,0.067-7.472,3.776-7.472,8.282c0,4.507,3.346,8.103,7.472,8.032 c4.125-0.071,7.467-3.779,7.467-8.283C1092.933,1778.945,1089.59,1775.349,1085.466,1775.416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1060.536,1756.766c-4.137,0.064-7.491,3.774-7.491,8.286c0,4.513,3.354,8.116,7.491,8.049 c4.135-0.067,7.485-3.777,7.485-8.286C1068.021,1760.307,1064.671,1756.703,1060.536,1756.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1035.543,1738.069c-4.147,0.06-7.51,3.771-7.51,8.289c0,4.518,3.363,8.13,7.51,8.067 c4.146-0.063,7.504-3.774,7.504-8.289C1043.048,1741.62,1039.689,1738.009,1035.543,1738.069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1018.011,1711.037c-4.154,0.054-7.523,3.764-7.523,8.287c0,4.522,3.369,8.141,7.523,8.083 c4.153-0.057,7.518-3.767,7.518-8.286S1022.164,1710.984,1018.011,1711.037z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1007.979,1667.493c-4.159,0.045-7.531,3.749-7.531,8.273c0,4.525,3.372,8.153,7.531,8.105 c4.157-0.048,7.525-3.753,7.525-8.274C1015.504,1671.077,1012.135,1667.448,1007.979,1667.493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1517.379,1332.149l241.559,1.489c1.284,0.008,2.323-1.161,2.323-2.612 c0-1.452-1.039-2.633-2.323-2.641l-241.559-1.555c-1.317-0.009-2.383,1.174-2.383,2.645 C1514.997,1330.944,1516.063,1332.141,1517.379,1332.149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1751.965,1330.968c0,4.353,3.123,7.901,6.974,7.923c3.849,0.023,6.968-3.486,6.968-7.836 c0-4.351-3.119-7.898-6.968-7.924C1755.088,1323.105,1751.965,1326.614,1751.965,1330.968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1510.229,1329.444c0,4.409,3.202,8.001,7.15,8.025c3.947,0.023,7.145-3.529,7.145-7.934 c0-4.405-3.198-7.998-7.145-8.025C1513.431,1321.483,1510.229,1325.036,1510.229,1329.444z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000902452621987103510000013675791837163446961_",
    gradientUnits: "userSpaceOnUse",
    x1: 4922.4624,
    y1: -420.8028,
    x2: 4915.2217,
    y2: -1045.9541,
    gradientTransform: "matrix(-0.048 0.9988 -0.9988 -0.048 165.7905 -3065.4353)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000902452621987103510000013675791837163446961_)"
    },
    d: "M795.152,1941.248 c-27.791-1.335-50.833-26.46-51.366-56.062c-0.533-29.654,21.72-52.729,49.605-51.39c27.888,1.339,50.932,26.591,51.371,56.24 C845.202,1919.633,822.948,1942.583,795.152,1941.248z M793.77,1856.91c-15.908-0.764-28.611,12.395-28.319,29.316 c0.292,16.906,13.447,31.266,29.324,32.029c15.88,0.763,28.585-12.355,28.324-29.26 C822.836,1872.075,809.681,1857.674,793.77,1856.91z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062176457345938412890000007168746237016702882_",
    gradientUnits: "userSpaceOnUse",
    x1: 4967.8101,
    y1: -713.2097,
    x2: 4960.5825,
    y2: -1337.1967,
    gradientTransform: "matrix(-0.048 0.9988 -0.9988 -0.048 165.7905 -3065.4353)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062176457345938412890000007168746237016702882_)"
    },
    d: "M1037.708,1998.692 c-27.755-1.333-50.582-26.38-50.888-55.882c-0.308-29.561,22.096-52.56,49.945-51.222 c27.845,1.337,50.673,26.509,50.886,56.065C1087.864,1977.151,1065.46,2000.025,1037.708,1998.692z M1036.968,1914.627 c-15.888-0.763-28.679,12.352-28.515,29.222c0.163,16.848,13.195,31.163,29.052,31.925 c15.855,0.762,28.645-12.313,28.512-29.16C1065.884,1929.745,1052.852,1915.389,1036.968,1914.627z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020389819169604732990000003247177626678172805_",
    gradientUnits: "userSpaceOnUse",
    x1: 4792.4009,
    y1: -777.4365,
    x2: 4785.1357,
    y2: -1404.6993,
    gradientTransform: "matrix(-0.048 0.9988 -0.9988 -0.048 165.7905 -3065.4353)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020389819169604732990000003247177626678172805_)"
    },
    d: "M1276.572,1833.231 c-27.909-1.34-50.682-26.651-50.768-56.472c-0.087-29.881,22.623-53.133,50.627-51.788 c28.003,1.345,50.777,26.782,50.769,56.658C1327.191,1811.446,1304.482,1834.572,1276.572,1833.231z M1276.462,1748.259 c-15.977-0.767-28.942,12.492-28.905,29.545c0.037,17.03,13.039,31.496,28.985,32.262c15.945,0.766,28.91-12.453,28.903-29.482 C1305.439,1763.534,1292.438,1749.026,1276.462,1748.259z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168082209513506481940000004214777813179404444_",
    gradientUnits: "userSpaceOnUse",
    x1: 5109.7456,
    y1: -1124.0513,
    x2: 5102.5537,
    y2: -1744.9829,
    gradientTransform: "matrix(-0.048 0.9988 -0.9988 -0.048 165.7905 -3065.4353)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168082209513506481940000004214777813179404444_)"
    },
    d: "M1300.294,2154.553 c-27.627-1.327-50.154-26.144-50.217-55.37c-0.063-29.284,22.437-52.061,50.157-50.73c27.723,1.332,50.25,26.271,50.22,55.551 C1350.426,2133.226,1327.925,2155.881,1300.294,2154.553z M1300.248,2071.277c-15.814-0.76-28.66,12.23-28.634,28.941 c0.024,16.69,12.885,30.873,28.668,31.631c15.787,0.758,28.632-12.19,28.638-28.879 C1328.924,2086.26,1316.063,2072.037,1300.248,2071.277z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141413950784182674170000015950367242171789737_",
    gradientUnits: "userSpaceOnUse",
    x1: 1409.4958,
    y1: 4516.0283,
    x2: 1401.9265,
    y2: 3862.5244,
    gradientTransform: "matrix(0.9988 0.048 -0.048 0.9988 -337.0222 -2223.0181)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000141413950784182674170000015950367242171789737_)"
    },
    points: "930.464,2312.397  909.083,2311.37 906.713,2128.633 795.129,1916.225 813.878,1905.961 928.146,2123.788  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057142822849169038430000000379494258841786038_",
    gradientUnits: "userSpaceOnUse",
    x1: 1593.1394,
    y1: 4513.7139,
    x2: 1585.5863,
    y2: 3861.6057,
    gradientTransform: "matrix(0.9988 0.048 -0.048 0.9988 -337.0222 -2223.0181)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000057142822849169038430000000379494258841786038_)"
    },
    points: "1057.335,2318.491  1035.954,2317.464 1032.997,1987.016 1054.602,1988.053  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054945937219288639330000012245376999104239290_",
    gradientUnits: "userSpaceOnUse",
    x1: 1767.9318,
    y1: 4511.8384,
    x2: 1760.3361,
    y2: 3856.0486,
    gradientTransform: "matrix(0.9988 0.048 -0.048 0.9988 -337.0222 -2223.0181)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000054945937219288639330000012245376999104239290_)"
    },
    points: "1184.21,2324.584  1162.829,2323.558 1161.761,2106.822 1265.89,1939.923 1265.695,1821.132 1287.42,1822.175 1287.54,1947.737  1183.317,2114.558  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045593001475650666570000013734629482351693236_",
    gradientUnits: "userSpaceOnUse",
    x1: 1851.094,
    y1: 4510.3623,
    x2: 1843.575,
    y2: 3861.1912,
    gradientTransform: "matrix(0.9988 0.048 -0.048 0.9988 -337.0222 -2223.0181)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000045593001475650666570000013734629482351693236_)"
    },
    points: "1311.085,2330.678  1289.704,2329.651 1289.531,2139.034 1311.041,2140.067  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089544810575898691560000005304026627612146608_",
    gradientUnits: "userSpaceOnUse",
    x1: 3250.313,
    y1: -1116.9865,
    x2: 3243.4197,
    y2: -1712.1348,
    gradientTransform: "matrix(0 1 -1 0 388.4627 -848.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089544810575898691560000005304026627612146608_)"
    },
    d: "M1880.682,2399.039 c0-26.458,21.662-48.919,48.249-50.069c26.539-1.147,48.093,19.377,48.093,45.752c0,26.377-21.555,48.833-48.093,50.065 C1902.344,2446.021,1880.682,2425.5,1880.682,2399.039z M1956.406,2395.646c0-15.067-12.319-26.785-27.475-26.118 c-15.174,0.666-27.528,13.49-27.528,28.583c0,15.097,12.354,26.813,27.528,26.119 C1944.087,2423.536,1956.406,2410.715,1956.406,2395.646z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126313625236190159880000014929646364241977256_",
    gradientUnits: "userSpaceOnUse",
    x1: 3482.1462,
    y1: -1118.5603,
    x2: 3475.2334,
    y2: -1715.3838,
    gradientTransform: "matrix(0 1 -1 0 388.4627 -848.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126313625236190159880000014929646364241977256_)"
    },
    d: "M1839.204,2631.746 c0-26.498,21.721-49.156,48.378-50.512c26.614-1.353,48.228,19.034,48.228,45.448c0,26.41-21.614,49.064-48.228,50.501 C1860.926,2678.622,1839.204,2658.241,1839.204,2631.746z M1915.135,2627.765c0-15.09-12.352-26.729-27.552-25.946 c-15.211,0.784-27.599,13.72-27.599,28.837c0,15.115,12.388,26.752,27.599,25.94 C1902.783,2655.785,1915.135,2642.852,1915.135,2627.765z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156584998730398842660000005904464199633345665_",
    gradientUnits: "userSpaceOnUse",
    x1: 3702.2949,
    y1: -1125.8762,
    x2: 3695.4539,
    y2: -1716.5181,
    gradientTransform: "matrix(0 1 -1 0 388.4627 -848.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156584998730398842660000005904464199633345665_)"
    },
    d: "M1998.184,2850.475 c0-26.358,21.494-49.055,47.872-50.594c26.336-1.537,47.724,18.588,47.724,44.863c0,26.275-21.388,48.966-47.724,50.586 C2019.679,2896.953,1998.184,2876.834,1998.184,2850.475z M2073.322,2845.97c0-15.011-12.224-26.5-27.265-25.613 c-15.053,0.889-27.312,13.846-27.312,28.884c0,15.039,12.258,26.526,27.312,25.61 C2061.098,2873.936,2073.322,2860.981,2073.322,2845.97z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026135901395386311420000008832480747060565929_",
    gradientUnits: "userSpaceOnUse",
    x1: 3738.7837,
    y1: -1118.8136,
    x2: 3731.8103,
    y2: -1720.8616,
    gradientTransform: "matrix(0 1 -1 0 388.4627 -848.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026135901395386311420000008832480747060565929_)"
    },
    d: "M1707.94,2890.322 c0-26.609,21.909-49.551,48.797-51.141c26.844-1.586,48.645,18.704,48.645,45.228c0,26.526-21.8,49.463-48.645,51.135 C1729.849,2937.218,1707.94,2916.935,1707.94,2890.322z M1784.529,2885.674c0-15.151-12.46-26.734-27.792-25.818 c-15.343,0.918-27.838,14.015-27.838,29.195c0,15.184,12.495,26.764,27.838,25.819 C1772.069,2913.926,1784.529,2900.831,1784.529,2885.674z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112600788255968929700000018058566667550466995_",
    gradientUnits: "userSpaceOnUse",
    x1: 3320.3398,
    y1: -1112.4749,
    x2: 3313.3555,
    y2: -1715.4974,
    gradientTransform: "matrix(0 1 -1 0 388.4627 -848.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000112600788255968929700000018058566667550466995_)"
    },
    points: "1543.816,2540.072  1543.816,2519.253 1714.424,2511.02 1903.247,2398.396 1913.293,2415.929 1719.848,2531.458  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005972476256780159270000009247440055341375669_",
    gradientUnits: "userSpaceOnUse",
    x1: 3495.9788,
    y1: -1114.4291,
    x2: 3488.979,
    y2: -1718.7773,
    gradientTransform: "matrix(0 1 -1 0 388.4627 -848.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000005972476256780159270000009247440055341375669_)"
    },
    points: "1543.816,2663.61  1543.816,2642.791 1849.598,2626.802 1849.598,2647.414  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000218710795949603880000016330893959321060775_",
    gradientUnits: "userSpaceOnUse",
    x1: 3663.1057,
    y1: -1116.5796,
    x2: 3656.1418,
    y2: -1717.8218,
    gradientTransform: "matrix(0 1 -1 0 388.4627 -848.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000000218710795949603880000016330893959321060775_)"
    },
    points: "1543.816,2787.15  1543.816,2766.333 1745.817,2754.956 1902.267,2845.938 2008.468,2839.607 2008.468,2860.11 1896.166,2866.881  1739.652,2775.988  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034055522908035200470000002838957849755228805_",
    gradientUnits: "userSpaceOnUse",
    x1: 3744.9131,
    y1: -1117.1748,
    x2: 3737.8831,
    y2: -1724.1217,
    gradientTransform: "matrix(0 1 -1 0 388.4627 -848.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000034055522908035200470000002838957849755228805_)"
    },
    points: "1543.816,2910.693  1543.816,2889.874 1721.796,2879.132 1721.796,2899.831  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135667763352494821450000000281161354518235032_",
    gradientUnits: "userSpaceOnUse",
    x1: 1166.2615,
    y1: 2816.9082,
    x2: 931.1404,
    y2: 2521.189
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135667763352494821450000000281161354518235032_)"
    },
    d: "M1417.008,3150.771l-646.634,44.851 c-84.05,5.829-152.517-54.873-152.517-135.612v-635.92c0-80.739,68.467-148.924,152.517-152.279l646.634-25.819 c80.198-3.202,144.903,57.707,144.903,136.029v616.885C1561.911,3077.227,1497.206,3145.207,1417.008,3150.771z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039121558772680719770000016682437030737728654_",
    gradientUnits: "userSpaceOnUse",
    x1: 1687.9033,
    y1: 1768.015,
    x2: 530.8237,
    y2: 3706.1257
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039121558772680719770000016682437030737728654_)"
    },
    d: "M1438.285,3173.209l-646.634,44.851 c-84.05,5.83-152.518-54.874-152.518-135.612v-635.92c0-80.739,68.467-148.923,152.518-152.28l646.634-25.818 c80.197-3.202,144.904,57.707,144.904,136.029v616.885C1583.189,3099.666,1518.482,3167.647,1438.285,3173.209z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169539255259963820170000000393159022175622582_",
    gradientUnits: "userSpaceOnUse",
    x1: 1661.9177,
    y1: 1811.4709,
    x2: 538.6723,
    y2: 3692.9094
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000169539255259963820170000000393159022175622582_)"
    },
    d: "M1155.701,2902.715 c-79.006-98.182,0.555-171.965-83.562-283.892c-101.192-134.649-266.183-95.047-331.354-218.205 c-14.379-27.173-20.646-56.383-21.594-85.902c-47.633,26.65-80.057,76.283-80.057,131.812v635.92 c0,80.739,68.467,141.442,152.518,135.612l646.634-44.851c64.256-4.457,118.464-49.016,137.511-106.769 C1462.871,2950.863,1265.416,3039.061,1155.701,2902.715z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066505909311212782530000003564408357963473284_",
    gradientUnits: "userSpaceOnUse",
    x1: 1430.9257,
    y1: 3214.8518,
    x2: 1201.3292,
    y2: 2876.6289
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066505909311212782530000003564408357963473284_)"
    },
    d: "M1317.063,3013.117l-430.895,27.829 c-52.691,3.402-95.536-35.251-95.536-86.347v-424.303c0-51.096,42.844-94.464,95.536-96.858l430.895-19.578 c51.101-2.322,92.405,36.417,92.405,86.52v416.052C1409.467,2966.534,1368.163,3009.816,1317.063,3013.117z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174578290005022095490000018028598930471991957_",
    gradientUnits: "userSpaceOnUse",
    x1: 1236.4983,
    y1: 2476.427,
    x2: 634.1641,
    y2: 3769.2441
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174578290005022095490000018028598930471991957_)"
    },
    d: "M1329.264,3020.179l-424.766,27.25 c-51.942,3.333-94.176-34.519-94.176-84.553v-415.486c0-50.035,42.234-92.501,94.176-94.845l424.766-19.171 c50.374-2.274,91.09,35.661,91.09,84.722v407.406C1420.355,2974.563,1379.638,3016.947,1329.264,3020.179z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142859759550847373400000009788159137375673786_",
    gradientUnits: "userSpaceOnUse",
    x1: 1137.6021,
    y1: 2679.2288,
    x2: 738.2493,
    y2: 3536.3774
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000142859759550847373400000009788159137375673786_)"
    },
    d: "M1155.701,2902.716 c-79.006-98.183,0.555-171.966-83.562-283.893c-66.453-88.424-160.322-101.713-235.506-135.297 c-16.258,17.019-26.312,39.531-26.312,63.865v415.486c0,50.034,42.234,87.885,94.176,84.553l424.766-27.25 c22.54-1.446,43.106-10.766,58.991-24.967C1303.327,2984.77,1216.134,2977.818,1155.701,2902.716z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.61
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M969.164,2846.298l-20.899,73.82c-4.285,15.135-18.355,26.292-34.407,27.27l-17.435,1.063 c-24.067,1.468-41.306-19.868-34.261-42.435l99.297-318.023c4.579-14.666,18.4-25.202,34.043-25.967l64.344-3.138 c15.51-0.756,29.2,8.335,33.787,22.423l99.259,304.876c7.005,21.515-9.883,44.79-33.572,46.234l-21.028,1.282 c-15.561,0.948-29.294-8.107-33.78-22.286l-22.663-71.637L969.164,2846.298z M1069.043,2776.336l-24.472-79.215 c-7-22.173-14.001-49.99-19.838-72.243l-1.167,0.058c-5.842,22.857-11.684,51.925-18.114,74.265l-23.401,81.986 L1069.043,2776.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1346.57,2578.824v308.26c0,18.733-15.571,34.87-34.802,36.043l-18.023,1.098 c-19.277,1.176-34.921-13.101-34.921-31.887v-309.137c0-18.788,15.644-34.78,34.921-35.72l18.023-0.88 C1330.999,2545.663,1346.57,2560.09,1346.57,2578.824z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFC8D6"
    },
    d: "M3187.289,3179.365c-2.154,0-3.896-1.745-3.896-3.897V1907.535c0-2.152,1.742-3.897,3.896-3.897 c2.154,0,3.896,1.745,3.896,3.897v1267.933C3191.185,3177.62,3189.443,3179.365,3187.289,3179.365z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFC8D6"
    },
    d: "M2845.693,3099.716c-2.154,0-3.896-1.745-3.896-3.897V1875.564c0-2.152,1.742-3.897,3.896-3.897 s3.896,1.745,3.896,3.897v1220.255C2849.588,3097.971,2847.846,3099.716,2845.693,3099.716z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFC8D6"
    },
    d: "M2055.941,3156.54c-0.442,0-0.891-0.077-1.33-0.237c-2.021-0.733-3.069-2.968-2.334-4.993 l456.631-1258.211c0.735-2.023,2.97-3.069,4.995-2.332c2.021,0.733,3.069,2.969,2.334,4.993l-456.631,1258.211 C2059.03,3155.555,2057.533,3156.54,2055.941,3156.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFC8D6"
    },
    d: "M2393.042,3255c-0.381,0-0.766-0.058-1.15-0.175c-2.058-0.636-3.208-2.817-2.572-4.874 l409.826-1326.563c0.636-2.057,2.807-3.202,4.872-2.574c2.058,0.636,3.208,2.817,2.572,4.874l-409.826,1326.563 C2396.247,3253.925,2394.706,3255,2393.042,3255z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#97A6B7"
    },
    points: "2849.45,1874.296 3192.121,1899.657 3192.121,1907.366 2800.499,1924.92  2507.792,1889.055 2507.792,1881.348  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "2849.45,1866.588 3192.121,1899.657 2800.499,1917.213 2507.792,1881.348  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFC8D6"
    },
    d: "M2481.706,2968.012c-0.327,0-0.66-0.041-0.994-0.128l-326.276-85.598 c-2.082-0.546-3.324-2.677-2.78-4.758c0.544-2.081,2.657-3.334,4.76-2.781l326.276,85.598c2.082,0.546,3.324,2.677,2.78,4.758 C2485.013,2966.854,2483.434,2968.012,2481.706,2968.012z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFC8D6"
    },
    d: "M2574.133,2667.726c-0.225,0-0.453-0.019-0.684-0.06l-320.209-56.699 c-2.12-0.376-3.531-2.399-3.157-4.517s2.375-3.537,4.518-3.159l320.209,56.699c2.12,0.376,3.531,2.399,3.157,4.517 C2577.633,2666.398,2575.987,2667.726,2574.133,2667.726z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFC8D6"
    },
    d: "M2670.23,2357.781c-0.163,0-0.333-0.01-0.5-0.032l-309.904-39.948 c-2.137-0.276-3.644-2.229-3.368-4.363c0.272-2.132,2.218-3.647,4.362-3.367l309.904,39.948 c2.137,0.276,3.644,2.229,3.368,4.364C2673.84,2356.347,2672.163,2357.781,2670.23,2357.781z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFC8D6"
    },
    d: "M2731.808,2142.698c-0.198,0-0.402-0.015-0.606-0.048l-291.372-45.594 c-2.126-0.332-3.579-2.325-3.249-4.452c0.333-2.125,2.3-3.588,4.454-3.247l291.372,45.594c2.126,0.332,3.579,2.325,3.249,4.452 C2735.353,2141.325,2733.696,2142.698,2731.808,2142.698z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105394850422656341370000001392184862548497317_",
    gradientUnits: "userSpaceOnUse",
    x1: 688.9299,
    y1: 1760.39,
    x2: 704.6121,
    y2: 1959.9803,
    gradientTransform: "matrix(1 0 0 1 2051.7957 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105394850422656341370000001392184862548497317_)"
    },
    d: "M2771.31,1859.93 c0,0-63.126,28.691-64.157,33.27c-1.031,4.58,40.597-1.535,57.591-0.875c16.993,0.661,30.973-4.362,29.435-11.56 c-1.54-7.198-7.488-25.302-7.488-25.302L2771.31,1859.93z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029035658216906237680000006661443092705979279_",
    gradientUnits: "userSpaceOnUse",
    x1: 729.4149,
    y1: 1871.5087,
    x2: 726.5637,
    y2: 1664.7953,
    gradientTransform: "matrix(1 0 0 1 2051.7957 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029035658216906237680000006661443092705979279_)"
    },
    d: "M2769,1836.646l3.84,28.422 c0,0,9.994,3.557,16.707-0.649l2.864-31.172L2769,1836.646z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147922819248159635400000014275581591043640494_",
    gradientUnits: "userSpaceOnUse",
    x1: 985.2839,
    y1: 1737.1079,
    x2: 1000.9658,
    y2: 1936.694,
    gradientTransform: "matrix(1 0 0 1 2051.7957 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147922819248159635400000014275581591043640494_)"
    },
    d: "M3066.286,1837.328l7.342,11.787 c2.054,3.296,2.666,7.265,1.681,11.022c-2.568,9.802-7.696,28.905-9.932,33.885c-3.045,6.785-43.896,10.816-43.896,10.816 s-3.642-5.126,4.839-11.318c8.481-6.191,13.933-7.165,16.927-16.303c2.992-9.136,4.99-34.981,4.99-34.981L3066.286,1837.328z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025411310829555270800000009014364913267082900_",
    gradientUnits: "userSpaceOnUse",
    x1: 1001.01,
    y1: 1867.7633,
    x2: 998.1588,
    y2: 1661.0426,
    gradientTransform: "matrix(1 0 0 1 2051.7957 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025411310829555270800000009014364913267082900_)"
    },
    d: "M3035.724,1807.373 c2.682,2.138,15.802,41.962,15.802,41.962s4.247,5.431,12.315-2.584c8.067-8.015,3.651-3.595,3.651-3.595l-1.513-39.169 L3035.724,1807.373z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066501118301511544180000004115855046471401131_",
    gradientUnits: "userSpaceOnUse",
    x1: 680.0816,
    y1: 1536.6351,
    x2: 832.9214,
    y2: 1536.6351,
    gradientTransform: "matrix(1 0 0 1 2051.7957 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066501118301511544180000004115855046471401131_)"
    },
    d: "M2734.268,1265.632 c-3.331,84.782-3.466,176.894,1.412,275.297c5.492,110.809,16.53,213.226,30.439,306.066c5.171,0.165,10.605,0.192,16.281,0.033 c3.833-0.106,7.547-0.293,11.136-0.541c7.218-19.25,15.75-44.567,23.391-74.805c8.032-31.796,12.879-60.317,16.331-87.59 c12.156-96.027-2.09-104.405,7.776-175.571c8.737-63.028,21.163-65.489,35.749-154.974 c15.826-97.094,4.045-111.661-1.685-116.923C2850.709,1214.222,2793.417,1229.473,2734.268,1265.632z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154427872235641332570000007304050566106823316_",
    gradientUnits: "userSpaceOnUse",
    x1: 680.0812,
    y1: 1536.6417,
    x2: 832.9206,
    y2: 1536.6417,
    gradientTransform: "matrix(1 0 0 1 2051.7957 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000154427872235641332570000007304050566106823316_)"
    },
    d: "M2875.099,1236.625 c-23.263-21.368-76.463-8.432-132.654,24.179c64.642,69.84,71.689,115.146,63.939,144.542 c-8.758,33.224-35.385,42.793-35.284,79.123c0.125,44.645,40.418,56.471,39.561,103.714 c-0.566,31.239-18.272,30.915-22.453,69.499c-4.947,45.653,18.184,61.384,10.692,95.161 c-3.223,14.531-12.423,33.519-38.624,53.079c1.889,13.871,3.826,27.601,5.845,41.073c5.169,0.163,10.604,0.192,16.279,0.031 c3.833-0.106,7.548-0.292,11.135-0.54c7.219-19.25,15.751-44.565,23.392-74.804c8.032-31.797,12.879-60.317,16.331-87.591 c12.156-96.027-2.09-104.405,7.776-175.571c8.737-63.028,21.163-65.49,35.748-154.975 C2892.609,1256.451,2880.829,1241.885,2875.099,1236.625z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150787045582268460570000012426509144794285488_",
    gradientUnits: "userSpaceOnUse",
    x1: 722.5132,
    y1: 1521.5695,
    x2: 1030.1959,
    y2: 1521.5695,
    gradientTransform: "matrix(1 0 0 1 2051.7957 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150787045582268460570000012426509144794285488_)"
    },
    d: "M2774.309,1264.208 c55.658,81.44,115.693,182.797,169.381,304.116c40.573,91.681,69.999,177.762,91.603,254.479 c2.923,1.353,9.82,4.054,18.632,2.889c12.02-1.59,19.223-9.262,21.106-11.404c8.793-54.995,7.824-101.572,4.84-135.187 c-1.911-21.522-5.293-57.364-19.011-101.611c-15.366-49.563-25.93-52.348-45.977-104.784 c-20.807-54.426-15.767-68.008-35.693-136.119c-8.186-27.98-21.889-69.618-44.499-119.425 C2881.23,1232.844,2827.769,1248.526,2774.309,1264.208z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177479561896029962120000005477462207503046275_",
    gradientUnits: "userSpaceOnUse",
    x1: 716.9295,
    y1: 1509.106,
    x2: 830.2672,
    y2: 867.5734,
    gradientTransform: "matrix(-1 0 0 1 3512.7314 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177479561896029962120000005477462207503046275_)"
    },
    d: "M2517.338,1367.565 c10.704,16.646,47.545,14.7,72.707,5.703c58.831-21.036,96.481-95.856,99.795-155.395c0.712-12.784,0.261-25.281,2.851-25.661 c6.517-0.959,23.253,76.337,36.39,141.868c10.562,3.865,26.573,7.971,44.871,4.972c29.946-4.906,33.512-23.51,67.005-35.642 c19.542-7.077,38.689-7.094,76.984-7.127c43.229-0.038,44.42,5.293,52.747,1.426c0,0,2.059-1.13,3.831-2.403 c30.786-22.101-57.286-190.092-31.929-345.091c2.819-17.228,7.14-34.916-2.482-52.161 c-24.865-44.562-123.135-50.845-184.016-21.519c-16.687,8.038-44.635,25.624-69.594,44.158 c-9.976,7.407-20.351,15.699-31.174,25.152c-26.248,22.926-44.521,38.885-59.577,61.036 c-60.709,89.323,9.454,163.765-45.62,277.997C2531.191,1324.157,2506.129,1350.134,2517.338,1367.565z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070114477403440047460000013327848444876008337_",
    gradientUnits: "userSpaceOnUse",
    x1: 670.1516,
    y1: 974.9829,
    x2: 670.1516,
    y2: 851.4877,
    gradientTransform: "matrix(1 0 0 1 2051.7957 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070114477403440047460000013327848444876008337_)"
    },
    d: "M2680.57,860.44 c0,0,15.805,17.946,32.792,27.247c15.353,8.404,49.195-5.753,57.026-7.415c7.83-1.663-1.566,19.422-16.339,33.954 c-14.772,14.531-63.602,47.766-76.772,48.322c-13.17,0.557,2.121-10.977,10.208-24.406c8.088-13.43-3.31-41.196-13.517-49.751 C2663.76,879.834,2680.57,860.44,2680.57,860.44z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136412127752200995050000016538188180129945267_",
    gradientUnits: "userSpaceOnUse",
    x1: 433.5401,
    y1: 1384.3711,
    x2: 489.2132,
    y2: 1384.3711,
    gradientTransform: "matrix(1 0 0 1 2051.7957 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136412127752200995050000016538188180129945267_)"
    },
    d: "M2541.009,1366.966 c0,0-22.711,10.848-38.783,13.12c-16.073,2.271-19.566,15.11-15.104,19.828c4.461,4.717,30.039-0.449,38.593-5.261 C2534.267,1389.842,2541.009,1366.966,2541.009,1366.966z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059993051577279406480000006139308736670306487_",
    gradientUnits: "userSpaceOnUse",
    x1: -876.4014,
    y1: 335.3909,
    x2: -928.8441,
    y2: 202.1958,
    gradientTransform: "matrix(0.8789 -0.477 0.477 0.8789 3351.8735 210.4266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059993051577279406480000006139308736670306487_)"
    },
    d: "M2644.251,874.479 c-17.935-1.362-36.055-23.45-32.395-33.091c1.047-2.756,3.377-3.193,38.485-8.976c17.435-2.871,26.15-4.055,32.175,0.763 c3.678,2.94,6.549,8.185,7.455,13.138c0.465,2.55,0.49,6.059,0.053,13.052c-0.388,6.205-0.273,5.933-0.435,7.766 c-0.387,4.402-1.587,12.147-5.88,22.883c-1.788-1.961-4.156-4.302-7.144-6.61c-1.149-0.888-5.699-4.326-10.873-6.41 C2656.79,873.407,2650.073,874.921,2644.251,874.479z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003806174023226381680000017128589425802310573_",
    gradientUnits: "userSpaceOnUse",
    x1: 582.8572,
    y1: 939.3925,
    x2: 640.5953,
    y2: 827.124,
    gradientTransform: "matrix(1 0 0 1 2051.7957 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003806174023226381680000017128589425802310573_)"
    },
    d: "M2690.264,878.048 c0,0-0.798,17.16-16.968,24.695c-14.479,6.745-33.694-23.483-28.408-35.026c1.763-3.851,7.225-8.039,12.821-9.337 c3.306-0.767,4.927-0.106,10.303-1.463c4.958-1.252,5.921-2.405,7.836-2.019c2.395,0.482,5.448,3.207,7.729,13.872 c1.188-4.162,3.823-6.951,6.677-7.123c0.455-0.027,1.773,0.1,2.854,0.794C2697.025,864.952,2696.26,871.315,2690.264,878.048z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044143573923939146550000018187541922681031837_",
    gradientUnits: "userSpaceOnUse",
    x1: 1202.3732,
    y1: 1021.5444,
    x2: 462.7173,
    y2: 1612.2427,
    gradientTransform: "matrix(-1 0 0 1 3512.7314 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044143573923939146550000018187541922681031837_)"
    },
    d: "M2129.905,1102.631l967.769,24.898 c5.662,0.146,10.241,6.083,10.241,13.262v217.766c0,7.18-4.58,13.124-10.241,13.278l-967.769,26.292 c-8.306,0.226-15.057-6.666-15.057-15.392v-264.691C2114.848,1109.319,2121.598,1102.419,2129.905,1102.631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "#FFFFFF"
    },
    d: "M2155.8,1131.804l924.021,19.035c5.222,0.108,9.447,5.543,9.447,12.138V1336.4 c0,6.596-4.224,12.037-9.447,12.152l-924.021,20.366c-7.529,0.167-13.648-6.14-13.648-14.088v-208.92 C2142.151,1137.965,2148.271,1131.649,2155.8,1131.804z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M2246.935,1249.105c0,34.066-9.573,57.472-29.212,57.507 c-19.915,0.033-28.697-25.613-28.815-56.881c0-31.948,9.493-57.236,29.406-57.166 C2238.899,1192.637,2246.935,1218.938,2246.935,1249.105z M2207.057,1249.748c-0.118,25.3,4.149,37.352,11.138,37.345 c6.986-0.005,10.773-12.556,10.773-37.665c0-24.424-3.67-37.327-10.889-37.346 C2211.446,1212.065,2206.94,1224.108,2207.057,1249.748z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M2312.298,1249.165c0,33.965-9.515,57.302-29.039,57.335 c-19.796,0.034-28.525-25.536-28.643-56.71c0-31.851,9.437-57.065,29.232-56.995 C2304.31,1192.865,2312.298,1219.088,2312.298,1249.165z M2272.658,1249.806c-0.117,25.224,4.124,37.24,11.072,37.234 c6.944-0.005,10.708-12.52,10.708-37.553c0-24.351-3.648-37.216-10.824-37.234 C2277.02,1212.236,2272.541,1224.242,2272.658,1249.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M2343.843,1217.642h-0.236l-14.526,9.924l-2.93-19.255l20.149-13.445l14.739,0.05v109.598 l-17.195,0.028V1217.642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M2408.632,1217.794l-0.235,0l-14.44,9.896l-2.912-19.199l20.029-13.405l14.653,0.05v109.273 l-17.094,0.027V1217.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M2506.075,1249.341c0,33.665-9.347,56.797-28.527,56.828 c-19.448,0.034-28.023-25.31-28.138-56.208c0-31.57,9.271-56.558,28.716-56.492 C2498.228,1193.54,2506.075,1219.53,2506.075,1249.341z M2467.134,1249.977c-0.115,25.002,4.052,36.911,10.876,36.905 c6.822-0.006,10.52-12.41,10.52-37.222c0-24.134-3.583-36.886-10.633-36.904 C2471.419,1212.739,2467.018,1224.639,2467.134,1249.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M2537.067,1218.098l-0.233-0.002l-14.271,9.839l-2.878-19.087l19.794-13.325l14.481,0.049 v108.63l-16.893,0.028V1218.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M2600.721,1218.247l-0.231-0.001l-14.187,9.81l-2.861-19.031l19.677-13.286l14.396,0.049V1304.1 l-16.794,0.026V1218.247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M2696.459,1249.515c0,33.369-9.184,56.298-28.029,56.33 c-19.106,0.033-27.533-25.088-27.645-55.714c0-31.293,9.111-56.062,28.213-55.996 C2688.75,1194.202,2696.459,1219.965,2696.459,1249.515z M2658.198,1250.146c-0.113,24.782,3.98,36.586,10.687,36.58 c6.702-0.004,10.335-12.301,10.335-36.894c0-23.925-3.52-36.563-10.447-36.58 C2662.408,1213.234,2658.086,1225.031,2658.198,1250.146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M2726.91,1218.543l-0.229,0l-14.022,9.752l-2.827-18.918l19.449-13.211l14.229,0.049v107.68 l-16.6,0.027V1218.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M2821.536,1249.629c0,33.175-9.078,55.971-27.704,56.003 c-18.884,0.031-27.212-24.943-27.324-55.391c0-31.11,9.006-55.737,27.886-55.671 C2813.917,1194.638,2821.536,1220.251,2821.536,1249.629z M2783.719,1250.257c-0.111,24.638,3.936,36.374,10.564,36.367 c6.624-0.005,10.215-12.228,10.215-36.68c0-23.784-3.479-36.349-10.327-36.367 C2787.881,1213.56,2783.608,1225.288,2783.719,1250.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M2851.634,1218.837h-0.224l-13.86,9.696l-2.795-18.809l19.223-13.133l14.064,0.048v107.056 l-16.408,0.026V1218.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M2913.457,1218.983l-0.224,0l-13.78,9.667l-2.779-18.753l19.113-13.096l13.982,0.046v106.748 l-16.311,0.026V1218.983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M2974.921,1219.127h-0.222l-13.701,9.64l-2.764-18.7l19.003-13.059l13.902,0.047v106.44 l-16.219,0.026V1219.127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M3036.033,1219.271h-0.223l-13.621,9.611l-2.747-18.645l18.893-13.021l13.823,0.047v106.134 l-16.125,0.026V1219.271z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075852942589101779550000014434511064446932116_",
    gradientUnits: "userSpaceOnUse",
    x1: 452.3231,
    y1: 1462.3593,
    x2: 565.6607,
    y2: 820.827,
    gradientTransform: "matrix(-1 0 0 1 3512.7314 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075852942589101779550000014434511064446932116_)"
    },
    d: "M3077.127,1224.352 c24.241-11.882,76.575-42.312,92.665-98.369c26.789-93.32-68.483-182.334-117.67-215.64 c-56.393-38.187-113.06-44.354-147.497-48.101c-42.725-4.65-68.802-7.487-88.388,8.554 c-50.654,41.485-20.206,178.369,29.938,192.46c16.416,4.613,22.628-7.395,57.026-15.683 c11.202-2.698,94.809-22.839,138.285,21.384c30.429,30.952,34.316,86.428,12.831,138.287 C3061.92,1212.947,3069.524,1218.65,3077.127,1224.352z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102527346605816050410000012102603941593178282_",
    gradientUnits: "userSpaceOnUse",
    x1: 457.1886,
    y1: 1280.8132,
    x2: 469.512,
    y2: 1211.0583,
    gradientTransform: "matrix(-1 0 0 1 3512.7314 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102527346605816050410000012102603941593178282_)"
    },
    d: "M3072.234,1220.683l-12.834-9.626 c0,0-8.052,5.576-17.894,4.812c-5.364-0.415-12.482,2.806-14.086,4.51c-1.604,1.703-9.08,5.797,1.621,4.728 c10.699-1.07,12.417,1.912,10.926,7.259c-1.49,5.346-10.419,20.315-14.954,23.522c-4.535,3.208,8.474,5.346,13.82,3.387 c5.346-1.961,13.9-5.525,20.136-17.108C3061.245,1237.943,3072.234,1220.683,3072.234,1220.683z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiml);
export default __webpack_public_path__ + "static/media/aiml.cf5ff7d7def38a1a358c2ccbe7ff07da.svg";
export { ForwardRef as ReactComponent };